import { Navigate, Outlet } from 'react-router-dom'

import { useUserContext } from '@/contexts/UserContext.tsx'

export const AuthChecker = () => {
  const { user, isLoading } = useUserContext()

  if (!user && !isLoading) {
    return <Navigate to="/login" />
  }

  if (user && !isLoading && !user.username) {
    return <Navigate to="/welcome" />
  }

  return (
    <main>
      <Outlet />
    </main>
  )
}
